import moment from "moment";
import { DATE_FORMATS } from "../../../constants";
import {
  ApplicationStatus,
  INote,
  ISchoolStudentApplicationCardFrontEndModel,
  IStudentApplicationCardFrontEndModel,
  NoteType,
} from "../types";
import { EducationType } from "../../school/constants/types";

type TGetApplicationCancellationInfo = (
  application:
    | ISchoolStudentApplicationCardFrontEndModel
    | IStudentApplicationCardFrontEndModel,
) => {
  note: INote | null;
  isDisabled: boolean;
  warningIconTooltipText: string;
};

export const getApplicationCancellationInfo: TGetApplicationCancellationInfo = (
  application,
) => {
  let schoolRejectionNote: INote | null = null;

  if (application.status.type === ApplicationStatus.REJECTED) {
    schoolRejectionNote = {
      text: application.status.comment ?? "",
      date: "",
      type: NoteType.ApplicationRejection,
    };
  }

  let applicationOutdatedNote: string;

  switch (application.schoolType) {
    case EducationType.Higher:
    case EducationType.Secondary:
      applicationOutdatedNote = "The intake is already started";
      break;
    case EducationType.Language:
      applicationOutdatedNote = "The application is outdated";
      break;
    default:
      applicationOutdatedNote = "Outdated";
  }

  const note =
    application.studentCancellationNote ||
    application.schoolCancellationNote ||
    schoolRejectionNote;

  const isOutdated =
    application.schoolType === EducationType.Language
      ? moment(application.startDate, DATE_FORMATS.frontEnd)
          .add(1, "year")
          .isBefore(moment())
      : moment(application.startDate, DATE_FORMATS.frontEnd).isBefore(moment());

  const isDisabled = !!(
    application.studentCancellationNote ||
    application.schoolCancellationNote ||
    isOutdated ||
    application.status.type === ApplicationStatus.REJECTED
  );

  let warningIconTooltipText: string = "";

  if (application.studentCancellationNote) {
    warningIconTooltipText = "Canceled by student";
  } else if (application.schoolCancellationNote) {
    warningIconTooltipText = "Canceled by school";
  } else if (schoolRejectionNote) {
    warningIconTooltipText = "Rejected";
  } else if (isOutdated) {
    warningIconTooltipText = applicationOutdatedNote;
  }

  return {
    note,
    isDisabled,
    warningIconTooltipText,
  };
};
